import Box from "@mui/material/Box";
import Home from "./home/Home";
import OurStory from "./story/Ourstory";
import WhereWhen from "./whereWhen/whereWhen";
import Gallery from "./gallery/Gallery";
import Countdown from "./countdown/Countdown";
import Rsvp from "./rsvp/Rsvp";

// Décalage pour que l'ancre ne soit pas masquée par la navbar fixe.
const anchor = { scrollMarginTop: "70px" } as const;

// Page d'accueil unique : toutes les sections s'enchaînent et la navbar
// fait défiler vers la bonne ancre (id).
export default function Landing() {
  return (
    <Box>
      <Box id="home">
        <Home />
      </Box>
      <Box id="story" sx={anchor}>
        <OurStory />
      </Box>
      <Box id="where-when" sx={anchor}>
        <WhereWhen />
      </Box>
      <Box id="gallery" sx={anchor}>
        <Gallery />
      </Box>
      <Box id="countdown" sx={anchor}>
        <Countdown />
      </Box>
      <Box id="rsvp" sx={anchor}>
        <Rsvp />
      </Box>
    </Box>
  );
}
